// extracted by mini-css-extract-plugin
module.exports = {"transactionsCell":"transactionsCell__LIC5U"};